let pendingForm = null;

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('submit', function(e) {
    if (e.target.matches('[data-otg-form=""]')) {
      e.preventDefault();
      e.stopPropagation();
      pendingForm = e.target;
      document.getElementById('cartModal').classList.add('active');
      return false;
    }
  }, true);
});

function closeCartModal() {
  document.getElementById('cartModal').classList.remove('active');
  pendingForm = null;
}

function confirmAddToCart() {
  if (pendingForm) {
    pendingForm.submit(); // Actually submit the form - goes to cart page
  }
}